// Hover-to-open for desktop mega menu panels (Change 08).
// Activates only at ≥990px; click/keyboard still work at all sizes.

(function () {
  const CLOSE_DELAY = 120; // ms — prevents flicker on diagonal mouse moves

  function init() {
    const menus = Array.from(document.querySelectorAll('.header__inline-menu header-menu'));
    if (!menus.length) return;

    menus.forEach(function (menu) {
      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      if (!details || !summary) return;

      let timer = null;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(timer);

        // Close every other open panel immediately
        menus.forEach(function (other) {
          if (other !== menu) {
            const od = other.querySelector('details');
            if (od && od.open) {
              od.open = false;
              other.querySelector('summary').setAttribute('aria-expanded', 'false');
            }
          }
        });

        if (!details.open) {
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }
      });

      menu.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (typeof menu.close === 'function') {
            menu.close();
          } else {
            details.open = false;
            summary.setAttribute('aria-expanded', 'false');
          }
        }, CLOSE_DELAY);
      });
    });
  }

  if (window.matchMedia('(min-width: 990px)').matches) {
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', init)
      : init();
  }
})();
